// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1obRw","label":"SetPasswdForm_label__zZrQd"};